import { Component, Input } from '@angular/core';
import { Capa, CapaECTypes } from '../../audit.model';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { MatDialog } from '@angular/material';
import { CapaEditDialogComponent } from '../capa-edit-dialog/capa-edit-dialog.component';
import { filter } from 'rxjs/operators';
import { CapaService } from '../../capa.service';

@Component({
  selector: 'iaud-capa-detail-expansion',
  templateUrl: './capa-detail-expansion.component.html',
  styleUrls: ['./capa-detail-expansion.component.scss']
})
export class CapaDetailExpansionComponent  {

  dateFormat: string = DISPLAY_DATE_FORMAT;
  capaTypes = CapaECTypes;
  capaType: string;
  canUpdate : boolean;

  @Input()
  _capa: Capa;
  toEvidence: boolean = false;
  @Input() set capa(value: Capa) {
    this._capa = value;

    this.canUpdate = this._capa.canUpdate;
    
    if (value) {
      this.capaType = this.capaTypes.find(x => x.key === value.capaEcType).text;
    }
  }
  get capa(): Capa {
     return this._capa;
  }

  constructor(    
    private dialog: MatDialog,
    private capaService: CapaService,
  ) { 
  }

  editCapa(): void {
    const dialogRef = this.dialog.open(CapaEditDialogComponent, { data: { capa: this._capa} });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(res => {
        this.capaService.getCapa(res.capaId)
          .subscribe(o => this.capa = o);
      });
  }

}
